import React, { FC } from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import "../style.scss";
import {RialSeparator} from "../../../../utils/price-separator"

interface componentProps {
    item: object;
    giftCardPaymentHandler: any
}

const Product: FC<componentProps> = ({ item, giftCardPaymentHandler }) => {
    // @ts-ignore
    const { logo, title, rial, price , IsStockAvailable} = item

    return (
        <Grid item xs={12} sm={3} md={3} lg={2}>
            {/* @ts-ignore */}
            <Box className="giftCardItemBox">
                {/* @ts-ignore */}
                <Box className="giftCardItemBoxBody">
                    {/* @ts-ignore */}
                    <Box className="giftCardItemBoxImage">
                        <img src={logo}/>
                    </Box>
                </Box>

                {/* @ts-ignore */}
                <Box>
                    {/* @ts-ignore */}
                    <Box className="giftCardItemBoxBodyInfo">
                        <Typography className="info-item">{title}</Typography>
                        <Typography className="info-item item-price">{price} {title.search(/Steam/i) !== -1 ? "TL" : "$"}  </Typography>
                        {/* @ts-ignore */}
                        <Button
                            variant="contained"
                            className="w-100 text-white item-price-button round-btn"
                            size="large"
                            onClick={() => giftCardPaymentHandler(item)}
                            disabled={IsStockAvailable === 0 ? true : false}
                        >
                            {IsStockAvailable === 0 ? ('ناموجود') : (`${RialSeparator(String(rial))} ریال`)}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Grid>
    );
};

export default Product;
